
export const getLeafJsonPaths = (obj: object, recurse: boolean): string[] => {
  const keys = [];

  if (obj == null) {
    return keys;
  }

  for (const key of Object.keys(obj)) {
    const prop = obj[key];
    if (Array.isArray(prop)) {
      // Undefined
      continue;
    }
    else if (typeof prop === "object" && recurse) {
      const nestedKeys = getLeafJsonPaths(prop, recurse);
      keys.push(...nestedKeys.map(k => `${key}.${k}`));
    }
    else {
      keys.push(key);
    }
  }

  return keys;
};

/**
 * Given a JSON path in the form "x.y.z", return the value at "z".
 * Arrays are not supported.
 */
export const getValueAtPath = (obj: object, path: string): any => {
  if (obj == null) {
    return undefined;
  }

  if (Array.isArray(obj)) {
    throw new Error("Arrays are not supported");
  }

  const index = path.indexOf(".");
  if (index === 0) {
    return getValueAtPath(obj, path.substring(1));
  }
  else if (index > 0) {
    const key = path.substring(0, index);
    const rest = path.substring(index);
    return getValueAtPath(obj[key], rest);
  }
  else {
    return obj[path.replace(".", "")];
  }
};
